<div class="crud-item-page">
  <form [formGroup]="form">
    <div class="crud-item-section">

      <span>
        <mat-form-field matTooltip="Business Unit Address Id"
          [matTooltipDisabled]="disabledTooltip(this.businessUnitAddressId)">
          <mat-label i18n="@@type.BusinessUnitAddress.businessUnitAddressId">Business Unit Address Id</mat-label>
          <input matInput formControlName="businessUnitAddressId" id="businessUnitAddressId"
            (ngModelChange)="businessUnitAddressIdChanging($event)" [(ngModel)]="item.businessUnitAddressId"
            (ngModelChange)="businessUnitAddressIdChanged($event)" #businessUnitAddressId type="number"
            placeholder="Business Unit Address Id">
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Select a Business Unit from the list"
          [matTooltipDisabled]="disabledTooltip(this.businessUnit)">
          <mat-label i18n="@@type.BusinessUnitAddress.businessUnit">Business Unit</mat-label>
          <mat-select formControlName="businessUnit" id="businessUnit" (ngModelChange)="businessUnitChanging($event)"
            [(ngModel)]="item.businessUnit" (ngModelChange)="businessUnitChanged($event)" #businessUnit
            placeholder="Business Unit" [compareWith]="businessUnitCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let businessUnit of businessUnitSelectionList" [value]="businessUnit">
              {{businessUnitDisplay(businessUnit)}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Select a Addr Type from the list"
          [matTooltipDisabled]="disabledTooltip(this.addrType)" class="crud-item-input-wider">
          <mat-label i18n="@@type.BusinessUnitAddress.addrType">Addr Type</mat-label>
          <mat-select formControlName="addrType" id="addrType" (ngModelChange)="addrTypeChanging($event)"
            [(ngModel)]="item.addrType" (ngModelChange)="addrTypeChanged($event)" #addrType placeholder="Addr Type">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let addrType of addrTypeSelectionList" [value]="addrType.code">
              {{addrType.meaning}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>
    </div>

    <mat-divider></mat-divider>

    <div class="crud-item-section">
      
      <span>
        <mat-form-field matTooltip="Description" [matTooltipDisabled]="disabledTooltip(this.description)" class="crud-item-input-wide">
          <mat-label i18n="@@type.BusinessUnitAddress.description">Description</mat-label>
          <input matInput formControlName="description" id="description"              
              (ngModelChange)="descriptionChanging($event)" [(ngModel)]="item.description"              
              (ngModelChange)="descriptionChanged($event)" #description              
              maxlength="255" placeholder="Description">
        </mat-form-field>
      </span>
    </div>

    <mat-divider></mat-divider>

    <div class="crud-item-section">
      <span>
        <mat-form-field matTooltip="Addr1" [matTooltipDisabled]="disabledTooltip(this.addr1)"
          class="crud-item-input-wide">
          <mat-label i18n="@@type.BusinessUnitAddress.addr1">Addr1</mat-label>
          <input matInput formControlName="addr1" id="addr1" (ngModelChange)="addr1Changing($event)"
            [(ngModel)]="item.addr1" (ngModelChange)="addr1Changed($event)" #addr1 maxlength="255" placeholder="Addr1">
        </mat-form-field>
      </span>
    </div>

    <div class="crud-item-section">
      <span>
        <mat-form-field matTooltip="Addr2" [matTooltipDisabled]="disabledTooltip(this.addr2)"
          class="crud-item-input-wide">
          <mat-label i18n="@@type.BusinessUnitAddress.addr2">Addr2</mat-label>
          <input matInput formControlName="addr2" id="addr2" (ngModelChange)="addr2Changing($event)"
            [(ngModel)]="item.addr2" (ngModelChange)="addr2Changed($event)" #addr2 maxlength="255" placeholder="Addr2">
        </mat-form-field>
      </span>
    </div>

    <div class="crud-item-section">
      <span>
        <mat-form-field matTooltip="Addr3" [matTooltipDisabled]="disabledTooltip(this.addr3)"
          class="crud-item-input-wide" class="crud-item-input-wide">
          <mat-label i18n="@@type.BusinessUnitAddress.addr3">Addr3</mat-label>
          <input matInput formControlName="addr3" id="addr3" (ngModelChange)="addr3Changing($event)"
            [(ngModel)]="item.addr3" (ngModelChange)="addr3Changed($event)" #addr3 maxlength="255" placeholder="Addr3">
        </mat-form-field>
      </span>
    </div>

    <div class="crud-item-section">
      <span>
        <mat-form-field matTooltip="Town" [matTooltipDisabled]="disabledTooltip(this.town)"
          class="crud-item-input-wider">
          <mat-label i18n="@@type.BusinessUnitAddress.town">Town</mat-label>
          <input matInput formControlName="town" id="town" (ngModelChange)="townChanging($event)"
            [(ngModel)]="item.town" (ngModelChange)="townChanged($event)" #town maxlength="255" placeholder="Town">
        </mat-form-field>
      </span>
    </div>

    <div class="crud-item-section">
      <span>
        <mat-form-field matTooltip="County" [matTooltipDisabled]="disabledTooltip(this.county)"
          class="crud-item-input-wider">
          <mat-label i18n="@@type.BusinessUnitAddress.county">County</mat-label>
          <input matInput formControlName="county" id="county" (ngModelChange)="countyChanging($event)"
            [(ngModel)]="item.county" (ngModelChange)="countyChanged($event)" #county maxlength="255"
            placeholder="County">
        </mat-form-field>
      </span>
    </div>

    <div class="crud-item-section">
      <span>
        <mat-form-field matTooltip="Postcode" [matTooltipDisabled]="disabledTooltip(this.postcode)">
          <mat-label i18n="@@type.BusinessUnitAddress.postcode">Postcode</mat-label>
          <input matInput formControlName="postcode" id="postcode" (ngModelChange)="postcodeChanging($event)"
            [(ngModel)]="item.postcode" (ngModelChange)="postcodeChanged($event)" #postcode maxlength="8"
            placeholder="Postcode">
        </mat-form-field>
      </span>
    </div>

    <mat-divider></mat-divider>

    <div class="crud-item-section">

      <span>
        <mat-form-field matTooltip="Created By" [matTooltipDisabled]="disabledTooltip(this.createdBy)">
          <mat-label i18n="@@type.BusinessUnitAddress.createdBy">Created By</mat-label>
          <input matInput formControlName="createdBy" id="createdBy" (ngModelChange)="createdByChanging($event)"
            [(ngModel)]="item.createdBy" (ngModelChange)="createdByChanged($event)" #createdBy maxlength="255"
            placeholder="Created By">
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Created Date" [matTooltipDisabled]="disabledTooltip(this.createdDate)">
          <mat-label i18n="@@type.BusinessUnitAddress.createdDate">Created Date</mat-label>
          <input matInput formControlName="createdDate" id="createdDate" (ngModelChange)="createdDateChanging($event)"
            [(ngModel)]="item.createdDate" (ngModelChange)="createdDateChanged($event)" #createdDate
            [matDatepicker]="createdDateDatePicker" placeholder="Created Date">
          <mat-datepicker-toggle matSuffix [for]="createdDateDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #createdDateDatePicker color="primary"></mat-datepicker>
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Updated By" [matTooltipDisabled]="disabledTooltip(this.updatedBy)">
          <mat-label i18n="@@type.BusinessUnitAddress.updatedBy">Updated By</mat-label>
          <input matInput formControlName="updatedBy" id="updatedBy" (ngModelChange)="updatedByChanging($event)"
            [(ngModel)]="item.updatedBy" (ngModelChange)="updatedByChanged($event)" #updatedBy maxlength="255"
            placeholder="Updated By">
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Updated Date" [matTooltipDisabled]="disabledTooltip(this.updatedDate)">
          <mat-label i18n="@@type.BusinessUnitAddress.updatedDate">Updated Date</mat-label>
          <input matInput formControlName="updatedDate" id="updatedDate" (ngModelChange)="updatedDateChanging($event)"
            [(ngModel)]="item.updatedDate" (ngModelChange)="updatedDateChanged($event)" #updatedDate
            [matDatepicker]="updatedDateDatePicker" placeholder="Updated Date">
          <mat-datepicker-toggle matSuffix [for]="updatedDateDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #updatedDateDatePicker color="primary"></mat-datepicker>
        </mat-form-field>
      </span>

    </div>

  </form>
</div>